import { render, staticRenderFns } from "./StatsMemberAge.vue?vue&type=template&id=206a9ae6&"
import script from "./StatsMemberAge.vue?vue&type=script&lang=js&"
export * from "./StatsMemberAge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports